import { render, staticRenderFns } from "./HomeHeader.vue?vue&type=template&id=20197c99&scoped=true"
import script from "./HomeHeader.vue?vue&type=script&lang=js"
export * from "./HomeHeader.vue?vue&type=script&lang=js"
import style0 from "./HomeHeader.vue?vue&type=style&index=0&id=20197c99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20197c99",
  null
  
)

export default component.exports